import React, { useState, useEffect } from 'react'
import 'antd/dist/reset.css';
import {  Route, Routes } from 'react-router-dom' 
//------------------------------------------------------设置
//客户管理
import ClientList from './system/client/ClientList'
//客户类型管理
import ClientTypeList from './system/clientType/ClientTypeList'

//部门管理
import DeptList from './system/dept/DeptList'
//操作员管理
import UserAdd from './system/user/UserAdd'
import UserList from './system/user/UserList'
import UserPassword from './system/user/UserPassword'
//银行账户管理
import AccountList from './system/account/AccountList'
//团队报账单》》》》》》》》》》》》》》》》》》》》》》》
//产品管理
import GoodsList from './system/report/goods/GoodsList'
//店铺管理
import ShopList from './system/report/shop/ShopList'
//团队报账单审批点
import ReportNodeList from './system/report/node/ReportNodeList'
import ReportNodeUpdate from './system/report/node/ReportNodeUpdate'
//收款单》》》》》》》》》》》》》》》》》》》》》》》
//收款类型管理
import IncomeTypeList from './system/income/incomeType/IncomeTypeList'
//收款单审批点
import IncomeNodeList from './system/income/node/IncomeNodeList'
//付款单》》》》》》》》》》》》》》》》》》》》》》》
//付款类型管理
import CostTypeList from './system/cost/costType/CostTypeList'
//付款单审批点
import CostNodeList from './system/cost/node/CostNodeList'
//费用单》》》》》》》》》》》》》》》》》》》》》》》
//费用类型管理
import ExpenseTypeList from './system/expense/expenseType/ExpenseTypeList'
//费用单审批点
import ExpenseNodeList from './system/expense/node/ExpenseNodeList'
//借款单》》》》》》》》》》》》》》》》》》》》》》》
//借款类型管理
import LoanTypeList from './system/loan/loanType/LoanTypeList'
//借款单审批点
import LoanNodeList from './system/loan/node/LoanNodeList'
//开票申请单》》》》》》》》》》》》》》》》》》》》》》》
//开票类型管理
import InvoiceTypeList from './system/invoice/invoiceType/InvoiceTypeList'
//开票申请单审批点
import InvoiceNodeList from './system/invoice/node/InvoiceNodeList'
//----------------------------------------------------------------------------------------------------------------------------------------单据
//团队报账单
import ReportList from './document/report/ReportList'
//收款单
import IncomeList from './document/income/IncomeList'
//付款单
import CostList from './document/cost/CostList'
//费用单
import ExpenseList from './document/expense/ExpenseList'
//借款单
import LoanList from './document/loan/LoanList'
//开票申请单
import InvoiceList from './invoice/invoice/InvoiceList'

//成本发票登记单
import CostInvoiceList from './invoice/cost/CostInvoiceList'
//费用发票登记单
import ExpenseInvoiceList from './invoice/expense/ExpenseInvoiceList'
//----------------------------------------------------------------------------------------------------------------------------------------网站
//软件包装
import WebLogin from './web/WebLogin'
import WebPassword from './web/WebPassword'
//系统內管理
import NotFoundPage from './desk/NotFoundPage'
import DeskHome from './desk/DeskHome'
import DeskAbout from './desk/DeskAbout'
import DeskCourse from './desk/DeskCourse'
import LoginGate from './cpn/LoginGate'
import PDFViewer from './cpn/PDFViewer'
//审批规则
import RuleList from './system/rule/RuleList'
//------------------------------------------------------往来账
import ArapList from './arap/ArapList'  
//报表
import StatisticProfit from './statistic/profit/StatisticProfit'
import StatisticArap from './statistic/arap/StatisticArap'  
//银行
import BankList from './bank/BankList'
//------------------------------------------------------报表
import { useJKspListQuery,
    useBaozhangdanListQuery,
    useTDspListQuery,
    useJiekuanListQuery,
    useFeiyongListQuery,
    useFYspListQuery,
    useDingdanzhichuListQuery,
    useFKspListQuery,
    useDingdanshouruListQuery,
    useSKspListQuery,
    useKaipiaodanListQuery,
    useKPSQspListQuery,
    useBumenListQuery,
    useQiyeyhzhListQuery,
} from './store/DianShangYeWuApi';
import { useYonghuListQuery } from './store/DianShangYeWuApi';
import useVersionCheck from './cpn/useVersionCheck';

function App() {    
    // 版本检测，每60秒检查一次是否有新版本
    useVersionCheck(60000);
    
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'));
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'));
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'));
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'));
    const yh_qx = JSON.parse(localStorage.getItem('jtg-caiwu_yh_qx'));
    //我的团队报账单
    const [reportList, setReportList] = useState([]);
    //已驳回的团队报账单数量
    const [reportRejectedNum, setReportRejectedNum] = useState(0);
    //团队报账单结束未读数量
    const [reportEndNeedReadNum, setReportEndNeedReadNum] = useState(0);
    const { data:reportData, isSuccess:reportIsSuccess } = useBaozhangdanListQuery({"dsbzd_qy_id": qy_id,},{skip:!qy_id, });
    useEffect(() => {
        if(reportIsSuccess && reportData.Status === 'success'){
            setReportList(reportData.Result);
            setReportRejectedNum(reportData.Result.filter((item) => item.dsbzd_state === '4'&& item.dsbzd_uid === yh_id).length);
            setReportEndNeedReadNum(reportData.Result.filter((item) => item.dsbzd_state === '5' && item.dsbzd_uid === yh_id).length);
        }
    }, [reportData, reportIsSuccess, yh_id]);
    //团队报账单审批数据
    const [reportSpList, setReportSpList] = useState([]);
    //需要我审批的团队报账单数量
    const [reportNeedApproveNum, setReportNeedApproveNum] = useState(0);
    //抄送给我的团队报账单数量
    const [reportNeedReadNum, setReportNeedReadNum] = useState(0);
    
    const {data:reportSpData, isSuccess:reportSpIsSuccess} = useTDspListQuery({dsbzd_sp_yh_id:yh_id},{skip:!yh_id, });
    useEffect(() => {
        if(reportSpIsSuccess && reportSpData.Status === 'success'){
            setReportSpList(reportSpData.Result);
            setReportNeedApproveNum(reportSpData.Result.filter((item) => item.dsbzd_sp_state === '2' && item.dsbzd_sp_jd_name === '审批').length);
            setReportNeedReadNum(reportSpData.Result.filter((item) => item.dsbzd_sp_state === '2' && item.dsbzd_sp_jd_name === '抄送').length);
        }
    }, [reportSpData, reportSpIsSuccess]);
//***************************************************************************************************************************************************************************************************** 收款单*/
    //我的收款单
    const [ddsrList, setDdsrList] = useState([]);
    //已驳回的付款单数量
    const [ddsrRejectedNum, setDdsrRejectedNum] = useState(0);
    //收款单结束未读数量
    const [ddsrEndNeedReadNum, setDdsrEndNeedReadNum] = useState(0);
    const { data:ddsrData, isSuccess:ddsrIsSuccess } = useDingdanshouruListQuery({"ddsr_qy_id": qy_id},{skip:!qy_id, });
    useEffect(() => {
        if(ddsrIsSuccess && ddsrData.Status === 'success'){
            setDdsrList(ddsrData.Result);
            setDdsrRejectedNum(ddsrData.Result.filter((item) => item.ddsr_state === '4' && item.ddsr_uid === yh_id).length);
            setDdsrEndNeedReadNum(ddsrData.Result.filter((item) => item.ddsr_state === '5' && item.ddsr_uid === yh_id).length);
        }
    }, [ddsrData, ddsrIsSuccess, yh_id]);
    //收款单审批数据
    const [ddsrSpList, setDdsrSpList] = useState([]);       
    //需要我审批的收款单数量
    const [ddsrNeedApproveNum, setDdsrNeedApproveNum] = useState(0);
    //抄送给我的收款单数量
    const [ddsrNeedReadNum, setDdsrNeedReadNum] = useState(0);
    const {data:ddsrSpData, isSuccess:ddsrSpIsSuccess} = useSKspListQuery({ddsr_sp_yh_id:yh_id},{skip:!yh_id, });   
    useEffect(() => {
        if(ddsrSpIsSuccess && ddsrSpData.Status === 'success'){
            setDdsrSpList(ddsrSpData.Result);           
            setDdsrNeedApproveNum(ddsrSpData.Result.filter((item) => item.ddsr_sp_state === '2' && item.ddsr_sp_jd_name === '审批').length);  
            setDdsrNeedReadNum(ddsrSpData.Result.filter((item) => item.ddsr_sp_state === '2' && item.ddsr_sp_jd_name === '抄送').length);
        }
    }, [ddsrSpData, ddsrSpIsSuccess, yh_id]);
//***************************************************************************************************************************************************************************************************** 付款单*/
    //我的付款单
    const [ddzcList, setDdzcList] = useState([]);
    //已驳回的付款单数量
    const [ddzcRejectedNum, setDdzcRejectedNum] = useState(0);
    //付款单结束未读数量
    const [ddzcEndNeedReadNum, setDdzcEndNeedReadNum] = useState(0);
    const { data:ddzcData, isSuccess:ddzcIsSuccess } = useDingdanzhichuListQuery({"ddzc_qy_id": qy_id,},{skip:!qy_id, });
    useEffect(() => {
        if(ddzcIsSuccess && ddzcData.Status === 'success'){
            setDdzcList(ddzcData.Result);
            setDdzcRejectedNum(ddzcData.Result.filter((item) => item.ddzc_state === '4' && item.ddzc_uid === yh_id).length);
            setDdzcEndNeedReadNum(ddzcData.Result.filter((item) => item.ddzc_state === '5' && item.ddzc_uid === yh_id).length);
        }
    }, [ddzcData, ddzcIsSuccess, yh_id]);
    //付款单审批数据
    const [ddzcSpList, setDdzcSpList] = useState([]);    
    //需要我审批的付款单数量
    const [ddzcNeedApproveNum, setDdzcNeedApproveNum] = useState(0);
    //抄送给我的付款单数量
    const [ddzcNeedReadNum, setDdzcNeedReadNum] = useState(0);
    const {data:ddzcSpData, isSuccess:ddzcSpIsSuccess} = useFKspListQuery({ddzc_sp_yh_id:yh_id},{skip:!yh_id, });
    useEffect(() => {
        if(ddzcSpIsSuccess && ddzcSpData.Status === 'success'){
            setDdzcSpList(ddzcSpData.Result);           
            setDdzcNeedApproveNum(ddzcSpData.Result.filter((item) => item.ddzc_sp_state === '2' && item.ddzc_sp_jd_name === '审批').length);
            setDdzcNeedReadNum(ddzcSpData.Result.filter((item) => item.ddzc_sp_state === '2' && item.ddzc_sp_jd_name === '抄送').length);
        }
    }, [ddzcSpData, ddzcSpIsSuccess]);
//***************************************************************************************************************************************************************************************************** 费用单*/
    //我的费用单
    const [expenseList, setExpenseList] = useState([]);
    //已驳回的费用单数量
    const [expenseRejectedNum, setExpenseRejectedNum] = useState(0);
    //费用单结束未读数量
    const [expenseEndNeedReadNum, setExpenseEndNeedReadNum] = useState(0);
    const { data:expenseData, isSuccess:expenseIsSuccess } = useFeiyongListQuery({"fy_qy_id": qy_id},{skip:!qy_id, });
    useEffect(() => {
        if(expenseIsSuccess && expenseData.Status === 'success'){
            setExpenseList(expenseData.Result);
            setExpenseRejectedNum(expenseData.Result.filter((item) => item.fy_state === '4' && item.fy_uid === yh_id).length);
            setExpenseEndNeedReadNum(expenseData.Result.filter((item) => item.fy_state === '5' && item.fy_uid === yh_id).length);
            }
    }, [expenseData, expenseIsSuccess, yh_id]);
    //费用单审批数据
    const [expenseSpList, setExpenseSpList] = useState([]);    
    //需要我审批的费用单数量
    const [expenseNeedApproveNum, setExpenseNeedApproveNum] = useState(0);
    //抄送给我的费用单数量
    const [expenseNeedReadNum, setExpenseNeedReadNum] = useState(0);
    const {data:expenseSpData, isSuccess:expenseSpIsSuccess} = useFYspListQuery({fy_sp_yh_id:yh_id},{skip:!yh_id, });
    useEffect(() => {
        if(expenseSpIsSuccess && expenseSpData.Status === 'success'){
            setExpenseSpList(expenseSpData.Result);           
            setExpenseNeedApproveNum(expenseSpData.Result.filter((item) => item.fy_sp_state === '2' && item.fy_sp_jd_name === '审批').length);
            setExpenseNeedReadNum(expenseSpData.Result.filter((item) => item.fy_sp_state === '2' && item.fy_sp_jd_name === '抄送').length);
        }
    }, [expenseSpData, expenseSpIsSuccess]);
//***************************************************************************************************************************************************************************************************** 借款单*/
    //我的借款单
    const [loanList, setLoanList] = useState([]);
    //已驳回的借款单数量
    const [loanRejectedNum, setLoanRejectedNum] = useState(0);
    //借款单结束未读数量
    const [loanEndNeedReadNum, setLoanEndNeedReadNum] = useState(0);
    const { data:loanData, isSuccess:loanIsSuccess } = useJiekuanListQuery({"jk_qy_id": qy_id,},{skip:!qy_id, });
    useEffect(() => {
        if(loanIsSuccess && loanData.Status === 'success'){
            setLoanList(loanData.Result);
            setLoanRejectedNum(loanData.Result.filter((item) => item.jk_state === '4' && item.jk_uid === yh_id).length);
            setLoanEndNeedReadNum(loanData.Result.filter((item) => item.jk_state === '5' && item.jk_uid === yh_id).length);
        }
    }, [loanData, loanIsSuccess, yh_id]);
    //借款单审批数据
    const [loanSpList, setLoanSpList] = useState([]);    
    //需要我审批的借款单数量
    const [loanNeedApproveNum, setLoanNeedApproveNum] = useState(0);
    //抄送给我的借款单数量
    const [loanNeedReadNum, setLoanNeedReadNum] = useState(0);
    const {data:loanSpData, isSuccess:loanSpIsSuccess} = useJKspListQuery({jk_sp_yh_id:yh_id},{skip:!yh_id, });
    useEffect(() => {
        if(loanSpIsSuccess && loanSpData.Status === 'success'){
            setLoanSpList(loanSpData.Result);           
            setLoanNeedApproveNum(loanSpData.Result.filter((item) => item.jk_sp_state === '2' && item.jk_sp_jd_name === '审批').length);
            setLoanNeedReadNum(loanSpData.Result.filter((item) => item.jk_sp_state === '2' && item.jk_sp_jd_name === '抄送').length);
        }
    }, [loanSpData, loanSpIsSuccess]);
//***************************************************************************************************************************************************************************************************** 开票申请*/
    //我的开票申请
    const [invoiceList, setInvoiceList] = useState([]);
    //已驳回的开票申请数量
    const [invoiceRejectedNum, setInvoiceRejectedNum] = useState(0);
    //开票申请单结束未读数量
    const [invoiceEndNeedReadNum, setInvoiceEndNeedReadNum] = useState(0);
    const {data:invoiceData, isSuccess:invoiceIsSuccess} = useKaipiaodanListQuery({"kpsq_qy_id": qy_id},{skip:!qy_id, });
    useEffect(() => {
        if(invoiceIsSuccess && invoiceData.Status === 'success'){
            setInvoiceList(invoiceData.Result);
            setInvoiceRejectedNum(invoiceData.Result.filter((item) => item.kpsq_state === '4' && item.kpsq_uid === yh_id).length);
            setInvoiceEndNeedReadNum(invoiceData.Result.filter((item) => item.kpsq_state === '5' && item.kpsq_uid === yh_id).length);
        }
    }, [invoiceData, invoiceIsSuccess, yh_id]);
    //开票申请审批数据
    const [invoiceSpList, setInvoiceSpList] = useState([]);    
    //需要我审批的开票申请数量
    const [invoiceNeedApproveNum, setInvoiceNeedApproveNum] = useState(0);
    //抄送给我的开票申请数量
    const [invoiceNeedReadNum, setInvoiceNeedReadNum] = useState(0);
    const {data:invoiceSpData, isSuccess:invoiceSpIsSuccess} = useKPSQspListQuery({kpsq_sp_yh_id:yh_id},{skip:!yh_id, });
    useEffect(() => {
        if(invoiceSpIsSuccess && invoiceSpData.Status === 'success'){
            setInvoiceSpList(invoiceSpData.Result);           
            setInvoiceNeedApproveNum(invoiceSpData.Result.filter((item) => item.kpsq_sp_state === '2' && item.kpsq_sp_jd_name === '审批').length);
            setInvoiceNeedReadNum(invoiceSpData.Result.filter((item) => item.kpsq_sp_state === '2' && item.kpsq_sp_jd_name === '抄送').length);
        }
    }, [invoiceSpData, invoiceSpIsSuccess]);
//***************************************************************************************************************************************************************************************************** 操作员*/
    const [useList, setUseList] = useState([]);
    const {data:useData, isSuccess:useIsSuccess} = useYonghuListQuery({yh_qy_id:qy_id},{skip:!qy_id, });
    useEffect(() => {
        if(useIsSuccess && useData.Status === 'success'){
            setUseList(useData.Result);
        }
    }, [useData, useIsSuccess]);
//***************************************************************************************************************************************************************************************************** 部门*/
    const [deptList, setDeptList] = useState([]);
    const {data:deptData, isSuccess:deptIsSuccess} = useBumenListQuery({d_qy_id:qy_id},{skip:!qy_id, });
    useEffect(() => {
        if(deptIsSuccess && deptData.Status === 'success'){
            setDeptList(deptData.Result);
        }
    }, [deptData, deptIsSuccess]);
//***************************************************************************************************************************************************************************************************** 银行账户*/
    const [bankAccountList, setBankAccountList] = useState([]);
    const {data:bankAccountData, isSuccess:bankAccountIsSuccess} = useQiyeyhzhListQuery({qyyhzh_qy_id:qy_id},{skip:!qy_id, });
    useEffect(() => {   
        if(bankAccountIsSuccess && bankAccountData.Status === 'success'){
            setBankAccountList(bankAccountData.Result);
        }
    }, [bankAccountData, bankAccountIsSuccess]);
    return (
            <Routes>    
                <Route path='/PDFViewer' element={<PDFViewer />}></Route>                
                <Route path='/WebPassword' element={<WebPassword />}></Route>
                <Route path='/WebLogin' element={<WebLogin />}></Route>
                <Route element={<LoginGate />}>
                    <Route 
                        path='/DeskHome' 
                        element={<DeskHome 
                                    ddsrRejectedNum={ddsrRejectedNum} 
                                    ddsrNeedApproveNum={ddsrNeedApproveNum} 
                                    ddsrNeedReadNum={ddsrNeedReadNum} 
                                    ddzcRejectedNum={ddzcRejectedNum}
                                    ddzcNeedApproveNum={ddzcNeedApproveNum}
                                    ddzcNeedReadNum={ddzcNeedReadNum}
                                    expenseRejectedNum={expenseRejectedNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum}
                                    expenseNeedReadNum={expenseNeedReadNum}
                                    loanRejectedNum={loanRejectedNum}
                                    loanNeedApproveNum={loanNeedApproveNum}
                                    loanNeedReadNum={loanNeedReadNum}
                                    reportRejectedNum={reportRejectedNum}
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                    yh_qx={yh_qx}
                                />}
                    />
                    <Route path='/DeskAbout' element={<DeskAbout />}></Route>
                    <Route path='/DeskCourse' element={<DeskCourse />}></Route> 
                    {/* ----------------------------------------------------------------系统 */}         
                    {/* //部门管理 */}                                  
                    <Route path='/DeptList' element={<DeptList />}></Route>                   
                    {/* //客户管理 */}                                  
                    <Route path='/ClientList' element={<ClientList />}></Route>
                    {/* //客户类型管理 */}                                  
                    <Route path='/ClientTypeList' element={<ClientTypeList />}></Route>
                 
                    <Route path='/GoodsList' element={<GoodsList />}></Route>
                    {/* //用户管理 */}                                  
                    <Route path='/UserAdd' element={<UserAdd />}></Route>
                    <Route path='/UserList' element={<UserList />}></Route>           
                    <Route path='/UserPassword' element={<UserPassword />}></Route> 
                    {/* //银行账户管理 */}                                  
                    <Route path='/AccountList' element={<AccountList />}></Route>
                    {/* //团队报账单审批点 */}                                  
                    <Route path='/ReportNodeList' element={<ReportNodeList />}></Route>
                    <Route path='/ReportNodeUpdate' element={<ReportNodeUpdate />}></Route>
                    {/* //店铺管理 */}                                  
                    <Route path='/ShopList' element={<ShopList />}></Route>
                    {/* //产品管理 */}                                  
                    <Route path='/GoodsList' element={<GoodsList />}></Route>
                    {/* //收款单审批点 */}                                  
                    <Route path='/IncomeNodeList' element={<IncomeNodeList />}></Route>
                    {/* //收款类型管理 */}                                  
                    <Route path='/IncomeTypeList' element={<IncomeTypeList />}></Route>
                    {/* //付款单审批点 */}                                  
                    <Route path='/CostNodeList' element={<CostNodeList />}></Route>
                    {/* //付款类型管理 */}                                  
                    <Route path='/CostTypeList' element={<CostTypeList />}></Route>
                    {/* //费用单审批点 */}                                  
                    <Route path='/ExpenseNodeList' element={<ExpenseNodeList />}></Route>
                    {/* //费用类型管理 */}                                  
                    <Route path='/ExpenseTypeList' element={<ExpenseTypeList />}></Route>
                    {/* //借款单审批点 */}                                  
                    <Route path='/LoanNodeList' element={<LoanNodeList />}></Route>
                    {/* //借款类型管理 */}                                  
                    <Route path='/LoanTypeList' element={<LoanTypeList />}></Route>
                    {/* //开票申请单审批点 */}                                  
                    <Route path='/InvoiceNodeList' element={<InvoiceNodeList />}></Route>
                    {/* //开票类型管理 */}                                  
                    <Route path='/InvoiceTypeList' element={<InvoiceTypeList />}></Route>         
                    {/* //审批规则 */}                                  
                    <Route 
                        path='/RuleList' 
                        element={<RuleList 
                            yh_qx={yh_qx}   
                            qy_id={qy_id} 
                            qy_name={qy_name} 
                            yh_id={yh_id} 
                            yh_name={yh_name}
                            useList={useList}
                            deptList={deptList}
                            ddsrRejectedNum={ddsrRejectedNum} 
                            ddsrNeedApproveNum={ddsrNeedApproveNum} 
                            ddsrNeedReadNum={ddsrNeedReadNum} 
                            ddzcRejectedNum={ddzcRejectedNum}
                            ddzcNeedApproveNum={ddzcNeedApproveNum}
                            ddzcNeedReadNum={ddzcNeedReadNum}
                            expenseRejectedNum={expenseRejectedNum}
                            expenseNeedApproveNum={expenseNeedApproveNum}
                            expenseNeedReadNum={expenseNeedReadNum}
                            loanRejectedNum={loanRejectedNum}
                            loanNeedApproveNum={loanNeedApproveNum}
                            loanNeedReadNum={loanNeedReadNum}
                            reportRejectedNum={reportRejectedNum}
                            reportNeedApproveNum={reportNeedApproveNum}
                            reportNeedReadNum={reportNeedReadNum}
                            invoiceRejectedNum={invoiceRejectedNum}
                            invoiceNeedApproveNum={invoiceNeedApproveNum}
                            invoiceNeedReadNum={invoiceNeedReadNum}
                            reportEndNeedReadNum={reportEndNeedReadNum}
                            ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                            ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                            expenseEndNeedReadNum={expenseEndNeedReadNum}
                            loanEndNeedReadNum={loanEndNeedReadNum}
                            invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                        />}
                    />
                    {/* ------------------------------------------------------------------------------------------------------------单据 */}     
                    {/* //团队报账单 */}                                  
                     <Route 
                        path='/ReportList' 
                        element={<ReportList 
                                    reportList={reportList} 
                                    reportRejectedNum={reportRejectedNum} 
                                    reportSpList={reportSpList} 
                                    reportNeedApproveNum={reportNeedApproveNum} 
                                    reportNeedReadNum={reportNeedReadNum} 
                                    loanRejectedNum={loanRejectedNum}
                                    loanNeedApproveNum={loanNeedApproveNum}
                                    loanNeedReadNum={loanNeedReadNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum} 
                                    expenseNeedReadNum={expenseNeedReadNum} 
                                    expenseRejectedNum={expenseRejectedNum} 
                                    ddzcNeedApproveNum={ddzcNeedApproveNum} 
                                    ddzcNeedReadNum={ddzcNeedReadNum} 
                                    ddzcRejectedNum={ddzcRejectedNum} 
                                    ddsrRejectedNum={ddsrRejectedNum}
                                    ddsrNeedApproveNum={ddsrNeedApproveNum}
                                    ddsrNeedReadNum={ddsrNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name} 
                                    yh_qx={yh_qx}
                                />}
                    />
                    {/* //收款单 */}                                  
                    <Route 
                        path='/IncomeList' 
                        element={<IncomeList 
                                    ddsrList={ddsrList} 
                                    ddsrSpList={ddsrSpList} 
                                    ddsrRejectedNum={ddsrRejectedNum} 
                                    ddsrNeedApproveNum={ddsrNeedApproveNum} 
                                    ddsrNeedReadNum={ddsrNeedReadNum} 
                                    ddzcRejectedNum={ddzcRejectedNum}
                                    ddzcNeedApproveNum={ddzcNeedApproveNum}
                                    ddzcNeedReadNum={ddzcNeedReadNum}
                                    expenseRejectedNum={expenseRejectedNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum}
                                    expenseNeedReadNum={expenseNeedReadNum}
                                    loanRejectedNum={loanRejectedNum}
                                    loanNeedApproveNum={loanNeedApproveNum}
                                    loanNeedReadNum={loanNeedReadNum}
                                    reportRejectedNum={reportRejectedNum}
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name} 
                                    yh_qx={yh_qx}
                                    />}
                    />
                    {/* //付款单 */}                                  
                    <Route 
                        path='/CostList' 
                        element={<CostList 
                                    ddzcList={ddzcList} 
                                    ddzcSpList={ddzcSpList} 
                                    ddsrRejectedNum={ddsrRejectedNum} 
                                    ddsrNeedApproveNum={ddsrNeedApproveNum} 
                                    ddsrNeedReadNum={ddsrNeedReadNum} 
                                    ddzcRejectedNum={ddzcRejectedNum}
                                    ddzcNeedApproveNum={ddzcNeedApproveNum}
                                    ddzcNeedReadNum={ddzcNeedReadNum}
                                    expenseRejectedNum={expenseRejectedNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum}
                                    expenseNeedReadNum={expenseNeedReadNum}
                                    loanRejectedNum={loanRejectedNum}
                                    loanNeedApproveNum={loanNeedApproveNum}
                                    loanNeedReadNum={loanNeedReadNum}
                                    reportRejectedNum={reportRejectedNum}
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name} 
                                    yh_qx={yh_qx}
                                />}
                    />
                    {/* //费用单 */}                                  
                    <Route 
                       path='/ExpenseList' 
                       element={<ExpenseList 
                                    expenseSpList={expenseSpList} 
                                    expenseNeedApproveNum={expenseNeedApproveNum} 
                                    expenseNeedReadNum={expenseNeedReadNum} 
                                    expenseList={expenseList} 
                                    expenseRejectedNum={expenseRejectedNum} 
                                    reportRejectedNum={reportRejectedNum}                
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    loanNeedApproveNum={loanNeedApproveNum} 
                                    loanNeedReadNum={loanNeedReadNum}   
                                    loanRejectedNum={loanRejectedNum} 
                                    ddzcNeedApproveNum={ddzcNeedApproveNum} 
                                    ddzcNeedReadNum={ddzcNeedReadNum} 
                                    ddzcRejectedNum={ddzcRejectedNum} 
                                    ddsrRejectedNum={ddsrRejectedNum}
                                    ddsrNeedApproveNum={ddsrNeedApproveNum}
                                    ddsrNeedReadNum={ddsrNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name} 
                                    yh_qx={yh_qx}
                                />}
                    />
                    {/* //借款单 */}                                  
                    <Route 
                       path='/LoanList' 
                       element={<LoanList 
                                    loanSpList={loanSpList} 
                                    loanNeedApproveNum={loanNeedApproveNum} 
                                    loanNeedReadNum={loanNeedReadNum} 
                                    loanList={loanList} 
                                    loanRejectedNum={loanRejectedNum} 
                                    reportRejectedNum={reportRejectedNum}
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum} 
                                    expenseNeedReadNum={expenseNeedReadNum} 
                                    expenseRejectedNum={expenseRejectedNum} 
                                    ddzcNeedApproveNum={ddzcNeedApproveNum} 
                                    ddzcNeedReadNum={ddzcNeedReadNum} 
                                    ddzcRejectedNum={ddzcRejectedNum} 
                                    ddsrRejectedNum={ddsrRejectedNum}
                                    ddsrNeedApproveNum={ddsrNeedApproveNum}
                                    ddsrNeedReadNum={ddsrNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name} 
                                    yh_qx={yh_qx}
                                />}
                    />
                    {/* //开票申请 */}                                  
                    <Route 
                        path='/InvoiceList' 
                        element={<InvoiceList 
                                    ddsrList={ddsrList}                                    
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name}
                                    invoiceList={invoiceList}
                                    invoiceSpList={invoiceSpList}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportRejectedNum={reportRejectedNum}
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    expenseRejectedNum={expenseRejectedNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum}
                                    expenseNeedReadNum={expenseNeedReadNum}
                                    loanRejectedNum={loanRejectedNum}
                                    loanNeedApproveNum={loanNeedApproveNum}
                                    loanNeedReadNum={loanNeedReadNum}
                                    ddzcRejectedNum={ddzcRejectedNum}
                                    ddzcNeedApproveNum={ddzcNeedApproveNum}
                                    ddzcNeedReadNum={ddzcNeedReadNum}
                                    ddsrRejectedNum={ddsrRejectedNum}
                                    ddsrNeedApproveNum={ddsrNeedApproveNum}
                                    ddsrNeedReadNum={ddsrNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                    yh_qx={yh_qx}
                                />}
                    />
                   
                    {/* //成本发票登记单 */}                                  
                    <Route 
                        path='/CostInvoiceList' 
                        element={<CostInvoiceList 
                                    ddsrRejectedNum={ddsrRejectedNum} 
                                    ddsrNeedApproveNum={ddsrNeedApproveNum} 
                                    ddsrNeedReadNum={ddsrNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportRejectedNum={reportRejectedNum}
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    expenseRejectedNum={expenseRejectedNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum}
                                    expenseNeedReadNum={expenseNeedReadNum}
                                    loanRejectedNum={loanRejectedNum}
                                    loanNeedApproveNum={loanNeedApproveNum}
                                    loanNeedReadNum={loanNeedReadNum}
                                    ddzcRejectedNum={ddzcRejectedNum}
                                    ddzcNeedApproveNum={ddzcNeedApproveNum}
                                    ddzcNeedReadNum={ddzcNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name}
                                    ddzcList={ddzcList}
                                    yh_qx={yh_qx}
                                />}
                    />
                    {/* //费用发票登记单 */}                                  
                    <Route 
                    path='/ExpenseInvoiceList' 
                    element={<ExpenseInvoiceList 
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name}
                                    expenseList={expenseList}
                                    expenseRejectedNum={expenseRejectedNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum}
                                    expenseNeedReadNum={expenseNeedReadNum}
                                    loanRejectedNum={loanRejectedNum}
                                    loanNeedApproveNum={loanNeedApproveNum}
                                    loanNeedReadNum={loanNeedReadNum}
                                    ddzcRejectedNum={ddzcRejectedNum}
                                    ddzcNeedApproveNum={ddzcNeedApproveNum}
                                    ddzcNeedReadNum={ddzcNeedReadNum}
                                    ddsrRejectedNum={ddsrRejectedNum}
                                    ddsrNeedApproveNum={ddsrNeedApproveNum}
                                    ddsrNeedReadNum={ddsrNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportRejectedNum={reportRejectedNum}
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                    yh_qx={yh_qx}
                                />}
                    ></Route>
                    {/* ------------------------------------------------------------------------------------------------------------往来账 */}     
                    {/* //往来账 */}                                  
                    <Route path='/ArapList' element={<ArapList />}></Route>
                    {/* ------------------------------------------------------------------------------------------------------------报表 */}     
                    <Route 
                        path='/StatisticProfit' 
                        element={<StatisticProfit 
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name} 
                                    yh_qx={yh_qx}
                                    ddsrRejectedNum={ddsrRejectedNum} 
                                    ddsrNeedApproveNum={ddsrNeedApproveNum} 
                                    ddsrNeedReadNum={ddsrNeedReadNum} 
                                    ddzcRejectedNum={ddzcRejectedNum}
                                    ddzcNeedApproveNum={ddzcNeedApproveNum}
                                    ddzcNeedReadNum={ddzcNeedReadNum}
                                    expenseRejectedNum={expenseRejectedNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum}
                                    expenseNeedReadNum={expenseNeedReadNum}
                                    loanRejectedNum={loanRejectedNum}
                                    loanNeedApproveNum={loanNeedApproveNum}
                                    loanNeedReadNum={loanNeedReadNum}
                                    reportRejectedNum={reportRejectedNum}
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                />}
                    />
                    <Route 
                        path='/StatisticArap' 
                        element={<StatisticArap 
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name} 
                                    yh_qx={yh_qx} ddsrRejectedNum={ddsrRejectedNum} 
                                    ddsrNeedApproveNum={ddsrNeedApproveNum} 
                                    ddsrNeedReadNum={ddsrNeedReadNum} 
                                    ddzcRejectedNum={ddzcRejectedNum}
                                    ddzcNeedApproveNum={ddzcNeedApproveNum}
                                    ddzcNeedReadNum={ddzcNeedReadNum}
                                    expenseRejectedNum={expenseRejectedNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum}
                                    expenseNeedReadNum={expenseNeedReadNum}
                                    loanRejectedNum={loanRejectedNum}
                                    loanNeedApproveNum={loanNeedApproveNum}
                                    loanNeedReadNum={loanNeedReadNum}
                                    reportRejectedNum={reportRejectedNum}
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                />}
                    />
                    {/* //银行 */}                                  
                    <Route 
                        path='/BankList' 
                        element={<BankList 
                                    qy_id={qy_id} 
                                    qy_name={qy_name} 
                                    yh_id={yh_id} 
                                    yh_name={yh_name} 
                                    yh_qx={yh_qx}
                                    bankAccountList={bankAccountList}
                                    deptList={deptList}
                                    ddsrRejectedNum={ddsrRejectedNum} 
                                    ddsrNeedApproveNum={ddsrNeedApproveNum} 
                                    ddsrNeedReadNum={ddsrNeedReadNum} 
                                    ddzcRejectedNum={ddzcRejectedNum}
                                    ddzcNeedApproveNum={ddzcNeedApproveNum}
                                    ddzcNeedReadNum={ddzcNeedReadNum}
                                    expenseRejectedNum={expenseRejectedNum}
                                    expenseNeedApproveNum={expenseNeedApproveNum}
                                    expenseNeedReadNum={expenseNeedReadNum}
                                    loanRejectedNum={loanRejectedNum}
                                    loanNeedApproveNum={loanNeedApproveNum}
                                    loanNeedReadNum={loanNeedReadNum}
                                    reportRejectedNum={reportRejectedNum}
                                    reportNeedApproveNum={reportNeedApproveNum}
                                    reportNeedReadNum={reportNeedReadNum}
                                    invoiceRejectedNum={invoiceRejectedNum}
                                    invoiceNeedApproveNum={invoiceNeedApproveNum}
                                    invoiceNeedReadNum={invoiceNeedReadNum}
                                    reportEndNeedReadNum={reportEndNeedReadNum}
                                    ddsrEndNeedReadNum={ddsrEndNeedReadNum}
                                    ddzcEndNeedReadNum={ddzcEndNeedReadNum}
                                    expenseEndNeedReadNum={expenseEndNeedReadNum}
                                    loanEndNeedReadNum={loanEndNeedReadNum}
                                    invoiceEndNeedReadNum={invoiceEndNeedReadNum}
                                />}
                    />
                </Route>
                <Route path="*" element={<NotFoundPage/>} />
            </Routes>
    )
}

export default App